import { useEffect, useState } from 'react';
import { TableList, Typography } from 'seagull';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import ServiceAccountingAutocomplete from "../ServiceAccountingAutocomplete/ServiceAccountingAutocomplete";
import { serviceTemplateModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import { useStore, useStoreActions } from "../../../store/store-context";
import { getAccountingDetails, getServiceTemplateMapStatus } from "../accounting.utils";
import { MapStatusView } from "../MapStatusView";
import styles from "./MapServicesRow.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MapServicesRow(props) {
  const {
    serviceTemplate,
    accountingItems,
    integratedItem,
    onChangeMap,
    testid,
    accounting
  } = props;
  const [selectedOption, setSelectedOption] = useState(integratedItem || null);
  const [mapStatus, setMapStatus] = useState(getServiceTemplateMapStatus({
    serviceTemplate,
    accounting,
    accountingItems
  }));
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  const {
    biCodes,
    testIdPrefix
  } = getAccountingDetails(accounting);
  const {
    logBI
  } = useStoreActions();
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  useEffect(() => {
    setMapStatus(getServiceTemplateMapStatus({
      serviceTemplate,
      accounting,
      accountingItems
    }));
  }, [serviceTemplate, accounting, accountingItems]);
  const onItemChange = async accountingItemToMap => {
    logBI(accountingItemToMap ? biCodes.linkService : biCodes.unlinkService, {
      vendorId,
      userId
    });
    setMapStatus('mapping');
    setSelectedOption(accountingItemToMap);
    try {
      await onChangeMap(serviceTemplate, accountingItemToMap ? {
        id: accountingItemToMap.id,
        type: accountingItemToMap.type
      } : undefined);
    } catch (e) {
      setMapStatus('failedToMap');
    }
  };
  return /*#__PURE__*/_jsx(TableList.Row, {
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/_jsx("div", {
        "data-testid": "service-template",
        children: /*#__PURE__*/_jsx(Typography, {
          skin: serviceTemplateModel.isDeleted(serviceTemplate) ? 'secondary' : 'standard',
          ellipsis: true,
          children: "".concat(serviceTemplate.name).concat(serviceTemplateModel.isDeleted(serviceTemplate) ? ' (Archived)' : '')
        })
      })
    }, {
      value: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testIdPrefix, "-service"),
        className: styles.autocompleteWrapper,
        children: /*#__PURE__*/_jsx(ServiceAccountingAutocomplete, {
          testid: "".concat(testIdPrefix, "-services-modal-autocomplete"),
          onItemChange: onItemChange,
          accountingItems: accountingItems,
          selectedOption: selectedOption,
          showAccountingMapPlaceHolder: false,
          accounting: accounting,
          isBundle: serviceTemplateModel.isBundle(serviceTemplate)
        })
      })
    }, ...(SERVICE_TEMPLATE_BUNDLE ? [{
      value: /*#__PURE__*/_jsx("div", {
        "data-testid": "".concat(testid, "-service-template-type"),
        children: /*#__PURE__*/_jsx(Typography, {
          children: serviceTemplateModel.isBundle(serviceTemplate) ? 'Bundle' : 'Service'
        })
      })
    }] : []), {
      value: /*#__PURE__*/_jsx(MapStatusView, {
        mapStatus: mapStatus
      })
    }]
  });
}